export default "__VITE_ASSET__$eU$76EI__"